// Weekly completion streak computed from events' completed_at timestamps.

function weekKey(d) {
  // ISO-ish week key: year + week number (Mon-based)
  const date = new Date(d);
  date.setHours(0, 0, 0, 0);
  // Thursday trick for ISO week
  const day = (date.getDay() + 6) % 7; // Mon=0
  date.setDate(date.getDate() - day + 3);
  const firstThursday = new Date(date.getFullYear(), 0, 4);
  const week = 1 + Math.round(((date - firstThursday) / 86400000 - 3 + ((firstThursday.getDay() + 6) % 7)) / 7);
  return `${date.getFullYear()}-W${String(week).padStart(2, "0")}`;
}

export function computeStreak(events) {
  const completed = events.filter((e) => e.completed_at);
  const weeks = new Set(completed.map((e) => weekKey(e.completed_at)));

  // count consecutive weeks ending at current week
  let streak = 0;
  const cursor = new Date();
  // if current week has no completion but last week does, streak still counts from last week
  let checking = new Date(cursor);
  let allowSkipCurrent = !weeks.has(weekKey(cursor));
  for (let i = 0; i < 260; i++) { // cap 5 years
    const key = weekKey(checking);
    if (weeks.has(key)) {
      streak += 1;
    } else {
      if (i === 0 && allowSkipCurrent) {
        // current week not done yet — don't break, let last week continue the streak
      } else {
        break;
      }
    }
    checking.setDate(checking.getDate() - 7);
  }

  const thisWeekKey = weekKey(new Date());
  const thisWeek = completed.filter((e) => weekKey(e.completed_at) === thisWeekKey).length;
  return { streak, thisWeek, totalCompleted: completed.length };
}
